import { render, staticRenderFns } from "./Cano.vue?vue&type=template&id=89279c52&scoped=true&"
import script from "./Cano.vue?vue&type=script&lang=js&"
export * from "./Cano.vue?vue&type=script&lang=js&"
import style0 from "./Cano.vue?vue&type=style&index=0&id=89279c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89279c52",
  null
  
)

export default component.exports